import AntiCopySwitch from './AntiCopySwitch'

export default AntiCopySwitch
